<svg:g [attr.class]="yAxisClassName" [attr.transform]="transform">
  @if (yScale) {
    <svg:g
      qmg-charts-y-axis-ticks
      [trimTicks]="trimTicks"
      [maxTickLength]="maxTickLength"
      [tickFormatting]="tickFormatting"
      [tickArguments]="tickArguments"
      [tickValues]="ticks"
      [tickStroke]="tickStroke"
      [scale]="yScale"
      [orient]="yOrient"
      [showGridLines]="showGridLines"
      [gridLineWidth]="dims.width"
      [referenceLines]="referenceLines"
      [referenceLinesOutlet]="referenceLinesOutlet"
      [showRefLines]="showRefLines"
      [showRefLabels]="showRefLabels"
      [height]="dims.height"
      (dimensionsChanged)="emitTicksWidth($event)"
      />
  }
  @if (showLabel) {
    <svg:g
      ngx-charts-axis-label
      [label]="labelText"
      [offset]="labelOffset"
      [orient]="yOrient"
      [height]="dims.height"
      [width]="dims.width"
      ></svg:g>
    }
    </svg:g>
